export function formatMaskedToken(keySuffix: string): string {
  return `***${keySuffix}`;
}
